/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["entries-container{display:block;height:100%;outline:0}entries-container .no-results-message{height:100%}"];
export { styles as styles };
